<template>
    <div class="dataBaseCenter">
        <slider @load-data="handleLoadData"></slider>
        <containerCenter :entity-id="selectId"></containerCenter>
    </div>
</template>

<script>
import slider from './slider';
import containerCenter from './containerCenter';
export default {
    components: { slider, containerCenter },
    props: { },
    data() {
        return {
            tableData: {},
            selectId: '',
        };
    },
    watch: {},
    computed: {},
    methods: {
        // 加载表格
        handleLoadData(id) {
            this.selectId = id;
        },
    },
    created() {},
    mounted() {},
};
</script>
<style lang="stylus" scoped>
.dataBaseCenter
    font-size 16px
    overflow hidden
</style>